import type { Theme } from '@mui/material/styles';
import { useSidebar } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';
import { Outlet } from '@tanstack/react-router';
import { HeaderProvider } from './Header';

const StyleSheet = {
  main: {
    flexGrow: 1,
    height: '100%',
    minWidth: 0,
    overflowX: 'auto',
    position: 'relative',
  },
  content: ({ isCollapsed }: { isCollapsed: boolean }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: (t: Theme) =>
      `${t.layout.content.topPadding}px ${t.layout.content.rightPadding}px ${t.layout.content.bottomPadding}px ${t.layout.content.leftPadding}px`,
    minWidth: (t: Theme) =>
      `calc(1440px - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`,
    width: '100%',
  }),
};

export default function Main() {
  const sidebar = useSidebar();

  if (!sidebar) {
    return null;
  }
  const { isCollapsed } = sidebar;
  return (
    <Box sx={StyleSheet.main} component="main">
      <Box sx={StyleSheet.content({ isCollapsed })}>
        <HeaderProvider>
          <Outlet />
        </HeaderProvider>
      </Box>
    </Box>
  );
}
